// extracted by mini-css-extract-plugin
export default {"root":"PhysicalActivity_root__7gQas","bubbleRoot":"PhysicalActivity_bubbleRoot__Mke6h","swimmer":"PhysicalActivity_swimmer__x8U1L"};